import React, { useEffect } from "react";
import { useDispatch } from "react-redux";
import { setShowNavbar, setShowFriends } from "../stores/uiState/UiStateSlice";

function Contact() {
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(setShowNavbar(true));
    dispatch(setShowFriends(false));
  }, []);

  return (
    <section className="LegalPage">
      <div className="legalContainer">
        <h1 className="legalTitle">Contact Us</h1>

        <div className="legalContent">
          <h2>Get in Touch</h2>
          <p>
            We&apos;d love to hear from you! Whether you have questions,
            feedback, or need support, feel free to reach out.
          </p>

          <h2>Email</h2>
          <p>
            For general inquiries, support, or feedback:{" "}
            <a href="mailto:contact@drafter.one">contact@drafter.one</a>
          </p>

          <h2>Report a Bug</h2>
          <p>
            Found a bug or something not working as expected? Please send us an
            email with a description of the issue, and we&apos;ll look into it
            as soon as possible.
          </p>

          <h2>Privacy & Data Requests</h2>
          <p>
            For questions about your data, account deletion requests, or
            privacy-related concerns, please email us at{" "}
            <a href="mailto:contact@drafter.one">contact@drafter.one</a>. We
            will respond within 30 days.
          </p>

          <h2>About Drafter</h2>
          <p>
            Drafter is an independent project created by League of Legends
            enthusiasts. We are not affiliated with or endorsed by Riot Games.
            Our goal is to bring the excitement of champion drafting to a wider
            audience through an engaging competitive game powered by AI
            analysis.
          </p>
        </div>
      </div>
    </section>
  );
}

export default Contact;
